import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Tooltip from '@material-ui/core/Tooltip'
import SendIcon from '@material-ui/icons/Send'
import TextField from '@material-ui/core/TextField'
import classNames from 'classnames'
import TextFields from './TextFields'
import { handleBodyChange, sendText } from '../../actions/sms'
import language from 'utils/vast-languagepack'

const mapStateToProps = (state, { match }) => ({
  contactID: match.params.contactID ? match.params.contactID : null,
  sms: state.sms,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  handleBodyChange,
  sendText,
}, dispatch)

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
})

class SMSPage extends Component {
  handleChange = () => event => {
    this.props.handleBodyChange(event.target.value)
  }

  sendText = () => {
    this.props.sendText()
    this.props.history.push('/')
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <TextFields
          contactID={this.props.contactID}
        />
        <br />
        <TextField
          label="Body"
          fullWidth
          value={this.props.sms.body}
          onChange={this.handleChange()}
          className={classes.textField}
          margin="normal"
        />
        <Tooltip title={language.smsPage.labels.sendText} placement="left">
          <Button
            color="secondary"
            variant="fab"
            aria-label="Send text"
            className={classNames(classes.button, classes.floatingActionButton)}
            onClick={this.sendText}
          >
            <SendIcon />
          </Button>
        </Tooltip>
      </div>
    )
  }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SMSPage)))
